import {FormCheckbox} from "@/Components/Controls";
import {useEffect, useState} from "react";
import {getCookie, setCookie} from "@/Utilities/CookieManager";


export default function BundleSummaryRemovableModule({index, module, bundle, bundleName, state, dispatch}) {

    const [includeModule, setIncludeModule] = useState(
        () => {

        let moduleName = module.name;

        let editBundle = state.bundles.filter(bundle => bundle.name === bundleName)[0];

        if(typeof getCookie(`${editBundle.name}-${module.name}-optional-module`) !== "undefined") {
            for(let optionalModuleCookie of getCookie(`${editBundle.name}-${module.name}-optional-module`)) {
                if(optionalModuleCookie.bundle === bundleName && module.name === moduleName) {
                    return optionalModuleCookie.value;
                }
            }
        } else {
            return true;
        }
    });

    useEffect(() => {

        let moduleName = module.name;

        state.cart.map(cartItem => {
            if (cartItem.type === "package" && cartItem.modules.length > 0) {
                cartItem.modules.map(module => {
                    if(!module.required && module.name === moduleName) {
                        if(includeModule) {
                            module.parentProductId = bundle.productId;
                            module.isIncluded = true;
                        } else {
                            module.parentProductId = null;
                            module.isIncluded = false;
                        }
                    }
                });
            }
        });

        let optionalModules = state.cart
            .filter(item => item.type === "package")
            .map(item => item.modules)
            .flat(1)
            .filter(item => (item.isIncluded && !item.required));

        let optionalModulePrices;

        if(optionalModules.length > 0) {
            optionalModulePrices = optionalModules.map(item => item.price).reduce((acc, curr) => acc + curr, 0);
        } else {
            optionalModulePrices = 0;
        }

        dispatch({ type: "optionalModuleTotalPrice", payload: { optionalModuleTotalPrice: optionalModulePrices }});

    }, [includeModule, state.cart])

    const toggleFreeModule = (e, value) => {
        setIncludeModule(value);

        let editBundle = state.bundles.filter(bundle => bundle.name === bundleName)[0];

        let newCookieValue = { bundle: editBundle.name, module: module.name, value: value };
        const optionalModuleCookie = `${editBundle.name}-${module.name}-optional-module`;
        setCookie(optionalModuleCookie, newCookieValue, 3);
    }

    return (
        <div className="optional-module" key={index}>
            <div className="bundle-summary-modules d-flex justify-content-between flex-row-reverse">
                <span className="optional-checkbox">
                    <FormCheckbox
                        checked={includeModule}
                        value={includeModule}
                        onChange={toggleFreeModule}/>
                </span>
                <span>
                    <img className={`summary-svg ${!includeModule ? "removed-module" : null}`} alt={module.sales_name ?? module.name} src={module.svg}/>
                    <span className={`summary-modules-name ${!includeModule ? "removed-module-name" : null}`}>{module.sales_name ?? module.name}</span>
                </span>
            </div>
        </div>
    )
}
